import { createSelector } from '@reduxjs/toolkit'
import { State } from '../types'

export const farmSelector = (chainId: number) =>
  createSelector(
    (state: State) => state.farms,
    (farms) => {
      const farmsData = farms.data.filter((farm) => farm.token?.chainId === chainId)
      const { userDataLoaded } = farms

      return {
        userDataLoaded,
        data: farmsData,
      }
    },
  )
